'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageTitle = function (_PureComponent) {
  _inherits(PageTitle, _PureComponent);

  function PageTitle() {
    _classCallCheck(this, PageTitle);

    return _possibleConstructorReturn(this, (PageTitle.__proto__ || Object.getPrototypeOf(PageTitle)).apply(this, arguments));
  }

  _createClass(PageTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appName = _props.appName,
          title = _props.title,
          rest = _objectWithoutProperties(_props, ['appName', 'title']);

      return _react2.default.createElement(_reactDocumentTitle2.default, _extends({ title: _underscore2.default.compact([appName, title]).join(' | ') }, rest));
    }
  }]);

  return PageTitle;
}(_react.PureComponent);

PageTitle.propTypes = {
  appName: _react.PropTypes.string,
  title: _react.PropTypes.string
};

PageTitle.demo = function () {
  return _react2.default.createElement(
    'div',
    { className: 'mg-top-md' },
    _react2.default.createElement(
      'h2',
      null,
      'Props'
    ),
    _react2.default.createElement(
      'p',
      null,
      'To see how changing the props affects the component, look at the title of this page in the browser tab.'
    ),
    _react2.default.createElement(_reactDemo2.default, {
      target: PageTitle,
      props: {
        appName: _reactDemo.props.string('App'),
        title: _reactDemo.props.string('Page')
      }
    })
  );
};

exports.default = PageTitle;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/PageTitle.js
// module id = 405
// module chunks = 0